import { render, staticRenderFns } from "./SendCertifiedSMSFirmaDialogComponent.vue?vue&type=template&id=5616f158&lang=pug"
import script from "./SendCertifiedSMSFirmaDialogComponent.vue?vue&type=script&lang=ts"
export * from "./SendCertifiedSMSFirmaDialogComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5616f158')) {
      api.createRecord('5616f158', component.options)
    } else {
      api.reload('5616f158', component.options)
    }
    module.hot.accept("./SendCertifiedSMSFirmaDialogComponent.vue?vue&type=template&id=5616f158&lang=pug", function () {
      api.rerender('5616f158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/customDialogs/firma/SendCertifiedSMSFirmaDialogComponent.vue"
export default component.exports